import React from 'react';
import {
  List,
  BulkDeleteWithConfirmButton,
  Datagrid,
  TextField,
  //EmailField,
  //EditButton,
  Filter,
  TextInput,
  ImageField
  //DateInput
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
// import {UserList} from '../users/Users';

const TruckFilter = (props) => (
  <Filter {...props}>
    {/* <TextInput label="Search" source="q" alwaysOn /> */}
    <TextInput source="vendorId" label="Vendor Id" alwaysOn />
    <TextInput source="Type" label="Truck Type" alwaysOn />
    <TextInput source="rcownername" label="RC Owner Name" alwaysOn />
    <TextInput source="platenumber" label="Register Number" alwaysOn />
    <TextInput source="servicecharge" label="Service Charge (per Kilometer)" />
  </Filter>
);

const rowClick = (/*id, basePath, record*/) => {
  // if (record.id === 0) {
  //   return 'show';
  // }
  return 'edit';
};

// const ShowEditButton = ({record, basePath, resource}) => {
//   return record.id !== 0 && <EditButton basePath={basePath} record={record} />;
// };

const TruckBulkActionButtons = (props) => <BulkDeleteWithConfirmButton {...props} />;

const styles = {
  image: {
    maxHeight: '50px',
    maxWidth: '50px',
    borderRadius: '30%'
  }
};
export const TruckList = ({classes, ...props}) => (
  <List title=" Truck" {...props} filters={<TruckFilter />} bulkActionButtons={<TruckBulkActionButtons />}>
    <Datagrid rowClick={rowClick} /*expand={<UserEdit/> }*/>
      <TextField source="vendorId" label="Vendor Id" />
      <TextField source="Type" label="Truck Type" />
      <TextField source="rcownername" label="RC Owner Name" />
      <TextField source="platenumber" label="Register Number" />
      <TextField source="servicecharge" label="Service Charge (per Kilometer)" />
      <TextField source="description" label="Description" />
      <ImageField source="toolImagePath" label="photo" classes={classes} />
    </Datagrid>
  </List>
);

export default withStyles(styles)(TruckList);
